import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Box,
} from "@mui/material";
import {
  AccountCircle,
  Logout,
  Settings,
  Dashboard,
  ViewKanban,
} from "@mui/icons-material";
import { AuthContext } from "../../context/AuthContext";

// Import logo
import logoImage from "../../assets/logo.png";

const Header = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfile = () => {
    handleMenuClose();
    // Profile view can be implemented here
  };

  const handleLogout = () => {
    handleMenuClose();
    logout();
    navigate("/login");
  };

  const handleSettings = () => {
    handleMenuClose();
    navigate("/settings");
  };

  const handleDashboard = () => {
    handleMenuClose();
    navigate("/dashboard");
  };

  const handleWorkflow = () => {
    handleMenuClose();
    navigate("/workflow");
  };

  return (
    <AppBar
      position="static"
      sx={{ backgroundColor: "#160E2B", color: "#ffffff" }}
    >
      <Toolbar>
        <Box
          display="flex"
          alignItems="center"
          gap={2}
          sx={{ flexGrow: 1, cursor: "pointer" }}
          onClick={() => navigate("/dashboard")}
        >
          <img
            src={logoImage}
            alt="CR Estimator Logo"
            style={{
              height: "40px",
              width: "auto",
              objectFit: "contain",
            }}
          />
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontWeight: 300,
              letterSpacing: "0.1em",
              color: "#ffffff",
              textTransform: "uppercase",
              display: { xs: "none", sm: "block" }, // Hide on mobile, show on larger screens
            }}
          >
            CR-Estimator
          </Typography>
        </Box>
        <Box display="flex" gap={1} alignItems="center">
          <IconButton sx={{ color: "#ffffff" }} onClick={handleDashboard}>
            <Dashboard />
          </IconButton>
          <IconButton sx={{ color: "#ffffff" }} onClick={handleWorkflow}>
            <ViewKanban />
          </IconButton>
          {(user?.role === "Super User" || user?.role === "Power User") && (
            <IconButton sx={{ color: "#ffffff" }} onClick={handleSettings}>
              <Settings />
            </IconButton>
          )}
          {user?.role === "Super User" && (
            <IconButton
              sx={{ color: "#ffffff" }}
              onClick={() => navigate("/users")}
            >
              <AccountCircle />
            </IconButton>
          )}
          <IconButton
            size="large"
            edge="end"
            aria-label="account menu"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenuOpen}
            sx={{ color: "#ffffff" }}
          >
            <Avatar
              sx={{
                width: 32,
                height: 32,
                bgcolor: "#C6E044",
                color: "#160E2B",
              }}
            >
              {user?.username?.charAt(0).toUpperCase()}
            </Avatar>
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleProfile}>
              <AccountCircle sx={{ mr: 1 }} />
              Profile
            </MenuItem>
            <MenuItem onClick={handleLogout}>
              <Logout sx={{ mr: 1 }} />
              Logout
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
